import { Button, PhonePlusSvg } from "@components/index";
import BuildingImg from "@assets/images/building.svg";

export const RequestCallCard = ({
  onRequestCall,
}: {
  onRequestCall: () => void;
}) => (
  <div className="flex w-full max-w-[414px] flex-col items-center rounded-lg border border-black-16 p-6">
    <img src={BuildingImg} alt="Request a Call" className="h-12 w-12" />
    <div className="pt-6 text-300 font-bold text-black-100">
      Want to Add or Remove a Business?
    </div>
    <div className="pt-1 font-light text-black-54">
      Please contact us by clicking the button below
    </div>
    <Button
      variant="text"
      title="Request a Call"
      leftIcon={<PhonePlusSvg />}
      className="mt-6 text-primary-300"
      onClick={() => onRequestCall()}
    />
  </div>
);
